import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Loader2 } from 'lucide-react';

const PipelineColumn = ({ 
  stage, 
  title, 
  icon: Icon, 
  color,
  count,
  value,
  defaultExpanded = false,
  onExpand,
  loading,
  children 
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = () => {
    const newState = !isExpanded;
    setIsExpanded(newState);
    if (newState && onExpand) {
      onExpand(stage);
    }
  };

  const formatCurrency = (val) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(val || 0);
  };

  return (
    <div 
      className="flex-shrink-0 w-80 snap-start"
      style={{ scrollSnapAlign: 'start' }}
    >
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-full flex flex-col">
        {/* Header - Sticky */}
        <div
          onClick={handleToggle}
          className="sticky top-0 z-10 bg-white rounded-t-lg cursor-pointer hover:bg-gray-50 transition-colors p-4 border-b border-gray-200"
          style={{ borderTopColor: color, borderTopWidth: '3px' }}
        >
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center space-x-2">
              {Icon && (
                <div 
                  className="p-2 rounded-lg" 
                  style={{ backgroundColor: `${color}15` }}
                >
                  <Icon className="h-4 w-4" style={{ color }} />
                </div>
              )}
              <h3 className="font-semibold text-[#2B2D42]">{title}</h3>
            </div>
            <button className="p-1 hover:bg-gray-200 rounded transition-colors">
              {isExpanded ? (
                <ChevronUp className="h-4 w-4 text-[#6C757D]" />
              ) : (
                <ChevronDown className="h-4 w-4 text-[#6C757D]" />
              )}
            </button>
          </div>
          
          <div className="flex items-center justify-between text-sm">
            <span className="text-[#6C757D]">
              {count} {count === 1 ? 'opportunity' : 'opportunities'}
            </span>
            <span className="font-semibold" style={{ color }}>
              {formatCurrency(value)}
            </span>
          </div>
        </div>

        {/* Content */}
        {isExpanded && (
          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            {loading ? (
              <div className="flex items-center justify-center py-8">
                <Loader2 className="h-6 w-6 animate-spin text-[#00B4D8]" />
              </div>
            ) : (
              children
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default PipelineColumn;
